export const T = {
  en_GB: {
    remove: "Remove",
    description: "Description",
    descriptionPlaceholder: "Description...",
    amountPlaceholder: "Amount...",
    amount: "Amount",
    type: "Type",
    monthly: "Monthly",
    annual: "Annual",
    addIncome: "Add Income",
    incomeAfterTax: "Income (after tax)",
    incomeStability: "Income Stability",
    selectStability: "Select stability...",
    stabilityPermanent: "Permanent/Stable",
    stabilityTemporary: "Temporary",
    stabilityVariable: "Variable",
    noItemsYet: "No items added yet. Click the button above to add.",
    fieldLabels: {
      employment: "Employment Income",
      self_employment: "Self-Employment Income",
      pension: "Pension Income",
      investment: "Investment Income",
      rental: "Rental Income",
      government: "Government Benefits",
      other_income: "Other Income",
    },
  },
  nb_NO: {
    remove: "Fjern",
    description: "Beskrivelse",
    descriptionPlaceholder: "Beskrivelse...",
    amountPlaceholder: "Beløp...",
    amount: "Beløp",
    type: "Type",
    monthly: "Månedlig",
    annual: "Årlig",
    addIncome: "Legg til inntekt",
    incomeAfterTax: "Inntekt (etter skatt)",
    incomeStability: "Inntektsstabilitet",
    selectStability: "Velg stabilitet...",
    stabilityPermanent: "Fast/Stabil",
    stabilityTemporary: "Midlertidig",
    stabilityVariable: "Variabel",
    noItemsYet: "Ingen poster lagt til ennå. Klikk på knappen over for å legge til.",
    fieldLabels: {
      employment: "Lønnsinntekt",
      self_employment: "Næringsinntekt",
      pension: "Pensjonsinntekt",
      investment: "Kapitalinntekt",
      rental: "Leieinntekt",
      government: "Offentlige ytelser",
      other_income: "Andre inntekter",
    },
  },
} as const;
